import { buildCreateEntityMutation, buildUpdateEntityMutation } from './entity';

export default {
  CREATE_ENTITY_MUTATION: buildCreateEntityMutation,
  UPDATE_ENTITY_MUTATION: buildUpdateEntityMutation
};
